import React from 'react';
import { ScrollableOverlay } from '../../scrollable-overlay/scrollable-overlay';
import { Button } from '../atoms/button/Button';
import { classes, style } from 'typestyle';
import { spacing } from '../../../theme/spacing';
import { rebrand } from '../../../theme/color';
import overlayStyles, { ScrollableOverlayBodyStyle } from '../../../styles/scrollable-overlay';
import { px, rem } from 'csx';
import { ButtonProminence, ButtonSize } from '../atoms/button/buttonStyles';
import { REGISTRATION_ROUTE } from '../../../constants';
import { ArrowRight } from '../atoms/icons/ArrowRight';
import AddToPlaylist from '../../../static/AddToPlaylist.png';
import Cursors from '../../../static/Cursors.png';

interface PlaylistSubscribeModalProps {
  show: boolean;
  onRequestClose(): void;
  sendMixpanel: (event: string, properties?: Record<string, any>) => void;
}

export const PlaylistSubscribeModal: React.FC<PlaylistSubscribeModalProps> = ({
  show,
  onRequestClose,
  sendMixpanel,
}) => {
  return (
    <ScrollableOverlay className={styles.wrapper} show={show} onRequestClose={onRequestClose}>
      <div className={overlayStyles.header} style={{ padding: '0 0 24px' }}>
        <h3 className={classes(styles.heading, overlayStyles.title)}>Subscribe to Create Playlists</h3>
      </div>
      <div className={styles.body}>
        <img src={AddToPlaylist} alt="Add to playlist illustration" />
        <img className={styles.cursorImage} src={Cursors} alt="Cursor icons indicating interaction" />
        <p className={styles.description}>
          You can create your very own playlists with a Lickd subscription to help organise and prep music for your
          videos
        </p>

        <Button prominence={ButtonProminence.SECONDARY} size={ButtonSize.MEDIUM} onClick={onRequestClose}>
          No, thanks
        </Button>

        <Button
          className={styles.button}
          prominence={ButtonProminence.PRIMARY}
          size={ButtonSize.MEDIUM}
          href={`${REGISTRATION_ROUTE}/plans`}
          onClick={() => {
            sendMixpanel('Logged out user clicks view plans in the playlist subscribe modal');
            onRequestClose();
          }}
        >
          View plans <ArrowRight />
        </Button>
      </div>
    </ScrollableOverlay>
  );
};

const styles = {
  description: style({
    fontSize: '16px',
    marginBottom: spacing.LARGE,
  }),
  body: style(ScrollableOverlayBodyStyle, {
    padding: '1.5rem 0 0',
    borderTop: `1px solid ${rebrand.light1.toString()}`,
    textAlign: 'center',
    $nest: {
      '& > p': {
        margin: '0 0 1.5rem',
        textAlign: 'center',
        lineHeight: px(24),
        fontWeight: 'bold',
      },
    },
  }),
  wrapper: style({ display: 'block', maxWidth: px(440) }),
  button: style({
    display: 'inline-flex',
    alignItems: 'center',
    gap: rem(0.5),
    marginLeft: spacing.DEFAULT,
  }),
  heading: style({
    fontSize: px(32),
  }),
  cursorImage: style({
    position: 'absolute',
    top: '50%',
    left: '49%',
    pointerEvents: 'none',
  }),
};
